import React from "react";

import Divider from "@busbud/design-system-components/dist/Divider";
import Label from "@busbud/design-system-components/dist/Label";
import Stack from "@busbud/design-system-components/dist/Stack";

import { useAppContext } from "@app/helpers/hooks";
import type { CreditsActivity } from "@app/types/loyalty";

import { CreditsActivityItem } from "./credits-activity-item";
import { NoActivity } from "./no-activity";

interface Props {
  credits_activity: CreditsActivity[];
}

type SortedActivities = { [month: string]: CreditsActivity[] };

const sortActivitiesByMonth = (
  credits_activity: CreditsActivity[]
): SortedActivities => {
  return credits_activity.reduce<SortedActivities>((activities, activity) => {
    const travelled_month = new Date(activity.travel_date).getMonth();

    if (!activities[travelled_month]) {
      activities[travelled_month] = [];
    }
    activities[travelled_month].push(activity);

    return activities;
  }, {});
};

export const CreditsActivityList: React.FC<Props> = ({ credits_activity }) => {
  const { intlProvider } = useAppContext();

  const sorted_activities = sortActivitiesByMonth(credits_activity);
  const sorted_months = Object.keys(sorted_activities).sort(
    (a, b) => parseInt(b) - parseInt(a)
  );

  if (credits_activity.length === 0) {
    return <NoActivity />;
  }

  return (
    <Stack
      direction="column"
      spacing={{
        xs: 2,
        md: 2.5
      }}
    >
      {sorted_months.map((month, index) => (
        <React.Fragment key={month}>
          <Stack direction="column" spacing={{ xs: 1.5, md: 2 }}>
            <Label size="sm" color="text.tertiary.opaque" fontWeight="bold">
              {intlProvider.formatDate(
                // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
                sorted_activities[month][0].travel_date,
                {
                  month: "long",
                  year: "numeric"
                }
              )}
            </Label>
            {/*
             // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591 */}
            {sorted_activities[month].map((activity: CreditsActivity) => (
              <CreditsActivityItem
                key={activity.purchase_id}
                activity={activity}
              />
            ))}
          </Stack>
          {index < sorted_months.length - 1 && <Divider />}
        </React.Fragment>
      ))}
    </Stack>
  );
};
